import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import { mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      error: false,
      achievementsOption: {
        spaceBetween: 32,
        loop: true,
        slidePerView: 1,
        cursor: 'grab',
        pagination: {
          el: '.js-achievements-pag',
          clickable: true,
        },
      },
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  components: {
    'banner-btn-cmp': BannerBtn,
  },
  methods: {
    errorData(data) {
      this.error = data.error
    },
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/become-vendor/index.js